/*
 * MAGREP – kärnan. Laddas på alla sidor.
 *  - window.MAGREP.state  { color, pack }  – vald färg och paket, gemensamt för hela sidan
 *  - CustomEvent 'magrep:color' / 'magrep:pack' på document när något ändras
 *  - Köpknappar, färgknappar, sticky köpbar, top bar, Lenis
 */
;(function () {
  'use strict'

  const cfgEl = document.getElementById('magrep-config')
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { colors: '', strings: {}, routes: { cartAdd: '/cart/add.js', cart: '/cart' } }
  const S = cfg.strings || {}
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  document.documentElement.classList.add('magrep-js')

  /* ── Färger: "Namn #HEX" per rad i temainställningarna ─────────────── */
  const norm = (s) => String(s || '').trim().toLowerCase()
  // "black|svart #1b1b1c" – flera namn för samma färg skiljs med |.
  const palette = String(cfg.colors || '')
    .split(/\r?\n/)
    .map((line) => {
      const m = line.trim().match(/^(.*?)\s*(#[0-9a-f]{3,8})\s*$/i)
      if (!m) return null
      const names = m[1].split('|').map((n) => n.trim()).filter(Boolean)
      return { name: names[0], keys: names.map(norm), hex: m[2] }
    })
    .filter(Boolean)

  // Glöd i flaskans egen färg. Mörka och grå färger får ett varmt vitt sken så de syns i mörkret.
  function glowFor(hex) {
    let h = hex.replace('#', '')
    if (h.length === 3) h = h.split('').map((c) => c + c).join('')
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16))
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    if (max < 60 || max - min < 25) return '#fff4e6'
    const mix = (c) => Math.round(c + (255 - c) * 0.35)
    return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`
  }

  /* ── Produkt ───────────────────────────────────────────────────────── */
  const dataEl = document.querySelector('script[data-magrep-product]')
  const product = dataEl ? JSON.parse(dataEl.textContent) : null
  const packOf = (v) => (/3/.test(v.pack || '') ? 'pack3' : /2/.test(v.pack || '') ? 'pack2' : 'single')

  // En post per färg som finns på produkten, i palettens ordning.
  const items = []
  if (product) {
    const byKey = new Map()
    product.variants.forEach((v) => {
      const key = norm(v.color)
      if (!byKey.has(key)) byKey.set(key, { key, name: v.label || v.color, variants: {}, image: null })
      const it = byKey.get(key)
      it.variants[packOf(v)] = v
      // Bilden från 1 st-varianten används i första hand.
      if (v.image && (!it.image || packOf(v) === 'single')) it.image = v.image
    })
    const used = new Set()
    const ordered = []
    palette.forEach((p) => {
      const key = p.keys.find((k) => byKey.has(k))
      if (key && !used.has(key)) used.add(key), ordered.push({ ...byKey.get(key), hex: p.hex })
    })
    byKey.forEach((it, key) => !used.has(key) && ordered.push({ ...it, hex: '#777777' }))
    ordered.forEach((it, index) => {
      it.index = index
      it.image = it.image || product.image
      it.glow = glowFor(it.hex)
      // Paket utan egna varianter = 2 eller 3 st av samma variant. Priset är det kassan tar:
      // antal × styckpris – utom när en riktig automatisk rabatt finns i Shopify och är bekräftad
      // i temainställningarna (då visas paketpriset och besparingen).
      ;[2, 3].forEach((q) => {
        const key = 'pack' + q
        const one = it.variants.single
        if (it.variants[key] || !one) return
        const deal = cfg['pack' + q + 'Discount'] && cfg['pack' + q + 'Price']
        let price = one.price * q
        if (deal) {
          // Paketpriset anges i SEK; i andra valutor samma rabatt i procent på det lokala styckpriset
          price = cfg.currency && cfg.currency !== 'SEK' ? Math.round((one.price * cfg['pack' + q + 'Price']) / (cfg.singlePriceSek || 34900)) : cfg['pack' + q + 'Price']
        }
        it.variants[key] = { ...one, price, qty: q, deal: !!deal }
      })
      it.available = Object.values(it.variants).some((v) => v.available)
      items.push(it)
    })
  }

  /* ── Pengar ────────────────────────────────────────────────────────── */
  const money = (cents) => {
    const n = cents / 100
    try {
      return new Intl.NumberFormat(cfg.locale === 'en' ? 'en-SE' : (cfg.locale || 'sv') + '-' + (cfg.country || 'SE'), {
        style: 'currency',
        currency: cfg.currency || 'SEK',
        minimumFractionDigits: n % 1 ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(n)
    } catch (e) {
      return `${n} kr`
    }
  }

  /* ── State ─────────────────────────────────────────────────────────── */
  const params = new URLSearchParams(location.search)
  // ?variant=<id> (Shopifys standard, t.ex. från annonser och varukorgen) väljer rätt färg; sedan ?farg=
  const urlVariant = Number(params.get('variant')) || 0
  const byVariant = urlVariant ? items.find((it) => Object.values(it.variants || {}).some((v) => v && v.id === urlVariant))?.key : null
  const startColor = byVariant || items.find((it) => it.key === norm(params.get('farg')))?.key || items.find((it) => it.available)?.key || items[0]?.key
  const state = { color: startColor, pack: 'single' }
  const itemFor = (key) => items.find((it) => it.key === key)
  const variantFor = (key, pack) => itemFor(key)?.variants[pack] || null

  function applyColorVars() {
    const it = itemFor(state.color)
    if (!it) return
    document.documentElement.style.setProperty('--m-hex', it.hex)
    document.documentElement.style.setProperty('--m-glow', it.glow)
    // Färgvärld (Ciro-referensen): hela scenen tonas efter vald flaska
    const k = String(it.key).toLowerCase()
    const world = { black: '#9aa4b4', white: '#dfe8f2', orange: '#ff6a24' }[Object.keys({ black: 1, white: 1, orange: 1 }).find((n) => k.includes(n))]
    document.documentElement.style.setProperty('--m-world', world || it.hex)
    document.documentElement.dataset.magrepColor = k
  }

  function setColor(key, source) {
    if (!itemFor(key) || key === state.color) return
    state.color = key
    applyColorVars()
    document.dispatchEvent(new CustomEvent('magrep:color', { detail: { color: key, item: itemFor(key), source } }))
    // Produktsidan: adressen följer vald variant (delbar länk, som i Dawn)
    const v = variantFor(key, 'single')
    if (v && document.body.dataset.template === 'product' && history.replaceState) {
      const u = new URL(location.href)
      u.searchParams.set('variant', v.id)
      history.replaceState(history.state, '', u)
    }
  }
  function setPack(pack) {
    if (!['single', 'pack2', 'pack3'].includes(pack)) return
    if (pack === state.pack) return
    state.pack = pack
    document.dispatchEvent(new CustomEvent('magrep:pack', { detail: { pack } }))
  }
  function stepColor(d) {
    const i = itemFor(state.color)?.index ?? 0
    setColor(items[(i + d + items.length) % items.length].key, 'step')
  }

  /* ── Köp ───────────────────────────────────────────────────────────── */
  async function buy(variant, btn) {
    if (!variant || !variant.available) return
    const label = btn?.querySelector('[data-magrep-buy-label]')
    const before = label?.textContent
    if (label) label.textContent = S.adding || '…'
    btn && (btn.disabled = true)
    track('AddToCart', { id: variant.id, value: variant.price / 100 })
    try {
      const drawer = document.querySelector('cart-drawer')
      const body = { items: [{ id: variant.id, quantity: variant.qty || 1 }] }
      if (!cfg.buyGoesToCheckout && drawer?.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id)
        body.sections_url = location.pathname
      }
      const res = await fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
      const json = await res.json()
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'cart')
      if (cfg.buyGoesToCheckout) {
        location.href = '/checkout'
        return
      }
      if (window.MAGREP_DRAWER) window.MAGREP_DRAWER.open() // MAGREPs varukorgslåda
      else if (drawer?.renderContents) {
        drawer.classList.remove('is-empty')
        drawer.renderContents(json)
      } else location.href = cfg.routes.cart
    } catch (e) {
      console.error('[MAGREP]', e)
      if (label) label.textContent = S.error || 'Fel'
      setTimeout(() => updateBuyButtons(), 2200)
      return
    } finally {
      btn && (btn.disabled = false)
    }
    if (label && before) label.textContent = before
    updateBuyButtons()
  }

  function updateBuyButtons() {
    const it = itemFor(state.color)
    document.querySelectorAll('[data-magrep-buy]').forEach((btn) => {
      const pack = packFor(btn)
      const v = variantFor(state.color, pack)
      const label = btn.querySelector('[data-magrep-buy-label]')
      let text
      if (!v) text = S.unavailable || 'Inte tillgänglig'
      else if (!v.available) text = S.soldOut || 'Slutsåld'
      else if (btn.dataset.label === 'short') text = S.buyShort || 'Köp nu'
      else if (btn.dataset.label === 'brand') text = (S.buyBrand || 'Köp MAGREP – {price}').replace('{price}', money(v.price))
      else if (btn.dataset.label === 'pack') text = (S.buyQty || 'Köp {qty} st – {price}').replace('{qty}', v.qty || 1).replace('{price}', money(v.price))
      else text = (S.buyNow || 'Köp nu – {price}').replace('{price}', money(v.price))
      if (label) label.textContent = text
      btn.disabled = !v || !v.available
      btn.setAttribute('aria-label', v ? `${text} – MAGREP ${it.name}` : text)
    })
    document.querySelectorAll('[data-magrep-text]').forEach((el) => {
      const k = el.dataset.magrepText
      const single = variantFor(state.color, 'single')
      const pack2 = variantFor(state.color, 'pack2')
      const pack3 = variantFor(state.color, 'pack3')
      const cur = variantFor(state.color, state.pack)
      const saving = (v, q) => (single && v?.deal && single.price * q > v.price ? money(single.price * q - v.price) : null)
      const map = {
        color: it?.name,
        'color-lower': it?.name.toLowerCase(),
        'price-single': single && money(single.price),
        'price-pack2': pack2 && money(pack2.price),
        'price-current': cur && money(cur.price),
        'price-pack2-each': pack2 && money(pack2.price / 2),
        'pack2-saving': saving(pack2, 2),
        'price-pack3': pack3 && money(pack3.price),
        'price-pack3-each': pack3 && money(pack3.price / 3),
        'pack3-saving': saving(pack3, 3),
        'pack-label': `${variantFor(state.color, state.pack)?.qty || 1} st`,
      }
      if (k in map) {
        const val = map[k]
        el.textContent = val || ''
        const wrap = el.closest('[data-magrep-hide-empty]')
        if (wrap) wrap.hidden = !val
      }
    })
    document.querySelectorAll('[data-magrep-img]').forEach((img) => {
      if (it?.image && img.getAttribute('src') !== it.image) {
        img.src = it.image
        img.alt = `MAGREP i ${it.name.toLowerCase()}`
      }
    })
  }

  document.addEventListener('click', (e) => {
    const packLink = e.target.closest('[data-magrep-set-pack]')
    if (packLink) setPack(packLink.dataset.magrepSetPack)
    const btn = e.target.closest('[data-magrep-buy]')
    if (!btn) return
    buy(variantFor(state.color, packFor(btn)), btn)
  })

  /* ── Färgknappar ───────────────────────────────────────────────────── */
  function renderSwatches(root) {
    root.innerHTML = ''
    items.forEach((it) => {
      const b = document.createElement('button')
      b.type = 'button'
      b.className = 'm-dot'
      b.setAttribute('role', 'radio')
      b.setAttribute('aria-label', it.available ? it.name : `${it.name} (${S.soldOut || 'slutsåld'})`)
      b.title = it.name
      b.dataset.color = it.key
      if (!it.available) b.setAttribute('aria-disabled', 'true')
      b.style.setProperty('--sw', it.hex)
      b.innerHTML = '<span class="m-dot__c"></span>'
      root.appendChild(b)
    })
    root.addEventListener('click', (e) => {
      const b = e.target.closest('.m-dot')
      if (b) setColor(b.dataset.color, 'swatch')
    })
    root.addEventListener('keydown', (e) => {
      const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]
      if (!d) return
      e.preventDefault()
      e.stopPropagation()
      stepColor(d)
      root.querySelector(`[data-color="${CSS.escape(state.color)}"]`)?.focus()
    })
  }
  function syncSwatches() {
    document.querySelectorAll('[data-magrep-swatches] .m-dot').forEach((b) => {
      const on = b.dataset.color === state.color
      b.setAttribute('aria-checked', on)
      b.tabIndex = on ? 0 : -1
    })
  }

  /* ── Paketval (radio-knappar med data-magrep-pack) ─────────────────── */
  // Paketvalet gäller sektionen det står i (2-pack är förvalt i paket-sektionen).
  // Färgen är däremot gemensam för hela sidan.
  function packFor(btn) {
    const mode = btn.dataset.magrepBuy
    if (mode === 'local') return btn.closest('[data-magrep-pack-host]')?.dataset.pack || 'single'
    if (mode === 'state') return state.pack
    return mode
  }
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-magrep-pack]')) return
    const host = e.target.closest('[data-magrep-pack-host]')
    if (host) host.dataset.pack = e.target.value
    else setPack(e.target.value)
    updateBuyButtons()
    document.dispatchEvent(new CustomEvent('magrep:pack', { detail: { pack: e.target.value, host } }))
  })
  function syncPack() {
    document.querySelectorAll('[data-magrep-pack-host]').forEach((host) => {
      host.querySelectorAll('[data-magrep-pack]').forEach((r) => (r.checked = r.value === host.dataset.pack))
    })
  }

  /* ── Sticky köpbar (mobil) ─────────────────────────────────────────── */
  function initSticky() {
    const bar = document.querySelector('[data-magrep-sticky]')
    if (!bar) return
    let heroVisible = true
    let bundlesVisible = false
    const update = () => bar.classList.toggle('is-visible', !heroVisible && !bundlesVisible)
    const heroBtn = document.getElementById('magrep-launch-buy') || document.getElementById('magrep-hero-buy')
    const bundles = document.querySelector('[data-magrep-bundles]')
    const story = document.querySelector('[data-mps]')
    if (story) {
      // Produktsidans 3D-berättelse: köpfältet syns i kapitlen utan egen köpknapp (1–4) och efter berättelsen
      let ch = 0
      let after = false
      const upd = () => bar.classList.toggle('is-visible', ((ch > 0 && ch < 5) || after) && !bundlesVisible)
      document.addEventListener('magrep:chapter', (e) => ((ch = e.detail.index), upd()))
      // "efter berättelsen" = berättelsens underkant har passerat skärmens mitt
      const onScroll = () => { const a = story.getBoundingClientRect().bottom < innerHeight * 0.5; if (a !== after) { after = a; upd() } }
      window.addEventListener('scroll', onScroll, { passive: true })
      if (bundles) new IntersectionObserver(([e]) => ((bundlesVisible = e.isIntersecting), upd())).observe(bundles)
      upd()
      return
    }
    if (heroBtn) new IntersectionObserver(([e]) => ((heroVisible = e.isIntersecting), update())).observe(heroBtn)
    else {
      heroVisible = false
      const onScroll = () => ((heroVisible = window.scrollY < 500), update())
      window.addEventListener('scroll', onScroll, { passive: true })
    }
    if (bundles) new IntersectionObserver(([e]) => ((bundlesVisible = e.isIntersecting), update())).observe(bundles)
    update()
  }

  /* ── Gymvideor i bakgrunden ────────────────────────────────────────── */
  function initBgVideos() {
    const mobile = window.matchMedia('(max-width: 749px)').matches
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          const v = e.target
          if (e.isIntersecting) {
            if (!v.src) v.src = mobile ? v.dataset.srcMobile : v.dataset.srcDesktop
            v.closest('.m-bg')?.classList.add('is-in') // crossfade in
            if (!reduced) v.play().catch(() => {})
          } else v.pause()
        }),
      { rootMargin: '200px' },
    )
    document.querySelectorAll('video[data-magrep-autoplay]').forEach((v) => io.observe(v))
    const fade = new IntersectionObserver((entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-in')), { rootMargin: '100px' })
    document.querySelectorAll('.m-bg').forEach((bg) => fade.observe(bg))
  }

  /* ── Top bar ───────────────────────────────────────────────────────── */
  function initTopbar() {
    document.querySelectorAll('[data-magrep-topbar]').forEach((bar) => {
      const msgs = [...bar.querySelectorAll('.magrep-topbar__msg')]
      if (!msgs.length) return
      let i = 0
      msgs[0].classList.add('is-active')
      if (reduced || msgs.length < 2) return
      setInterval(() => {
        const cur = msgs[i]
        cur.classList.remove('is-active')
        cur.classList.add('is-out')
        setTimeout(() => cur.classList.remove('is-out'), 450)
        i = (i + 1) % msgs.length
        msgs[i].classList.add('is-active')
      }, 3500)
    })
  }

  /* ── Lenis (mjuk scroll) ───────────────────────────────────────────── */
  function initLenis() {
    if (reduced || !window.Lenis || cfg.designMode) return
    const lenis = new window.Lenis({ lerp: 0.11, anchors: true, prevent: (node) => !!node.closest('cart-drawer, menu-drawer, details-modal, .menu-drawer') })
    MAGREP.lenis = lenis
    if (window.gsap && window.ScrollTrigger) {
      lenis.on('scroll', window.ScrollTrigger.update)
      window.gsap.ticker.add((t) => lenis.raf(t * 1000))
      window.gsap.ticker.lagSmoothing(0)
    } else {
      const raf = (t) => (lenis.raf(t), requestAnimationFrame(raf))
      requestAnimationFrame(raf)
    }
    // Stoppa när Dawn låser scrollen (kundvagn, meny).
    new MutationObserver(() => (document.body.classList.contains('overflow-hidden') ? lenis.stop() : lenis.start())).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  /* ── Spårning (Meta/TikTok läggs in via Shopify Customer Events) ───── */
  function track(event, data) {
    document.dispatchEvent(new CustomEvent('magrep:track', { detail: { event, ...data, color: state.color, pack: state.pack } }))
  }

  /* ── Publikt ───────────────────────────────────────────────────────── */
  const MAGREP = (window.MAGREP = window.MAGREP || {})
  Object.assign(MAGREP, { cfg, product, items, palette, state, setColor, setPack, stepColor, variantFor, itemFor, money, reduced, track, renderSwatches })

  function init() {
    applyColorVars()
    document.querySelectorAll('[data-magrep-swatches]').forEach(renderSwatches)
    syncSwatches()
    syncPack()
    updateBuyButtons()
    initSticky()
    initTopbar()
    initBgVideos()
    initLenis()
    document.addEventListener('magrep:color', () => (syncSwatches(), updateBuyButtons()))
    document.addEventListener('magrep:pack', () => (syncPack(), updateBuyButtons()))
    document.dispatchEvent(new CustomEvent('magrep:ready'))
    MAGREP.ready = true
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()
})()
